import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { format, parse, isValid } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

interface CustomDatePickerProps {
  field: { value?: string; onChange: (value: string) => void };
  error?: { message?: string };
  minDate?: Date; // Optional minDate
  maxDate?: Date; // Optional maxDate
  id?: string;
  className?: string;
  wrapperClassName?: string;
  placeholderText?: string;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  field,
  error,
  minDate,
  maxDate,
  id,
  className = "form-control",
  wrapperClassName = "w-100",
  placeholderText = "mm/dd/yyyy",
}) => {
  const [inputValue, setInputValue] = useState(field.value || "");

  const handleDateChange = (date: Date | null) => {
    if (date) {
      const formattedDate = format(date, "MM/dd/yyyy");
      setInputValue(formattedDate);
      field.onChange(formattedDate);
    } else {
      setInputValue("");
      field.onChange("");
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);

    const parsedDate = parse(value, "MM/dd/yyyy", new Date());

    if (isValid(parsedDate) && value.length === 10) {
      field.onChange(format(parsedDate, "MM/dd/yyyy"));
    }
  };

  return (
    <div className={wrapperClassName}>
      <DatePicker
        id={id}
        minDate={minDate} // Optional min date
        maxDate={maxDate} // Optional max date
        selected={field.value ? parse(field.value, "MM/dd/yyyy", new Date()) : null}
        onChange={handleDateChange}
        placeholderText={placeholderText}
        showMonthDropdown
        showYearDropdown
        customInput={
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            className={`${className} ${error?.message ? "is-invalid" : ""}`}
            //placeholder={placeholderText}
          />
        }
      />
      {error?.message && <div className="invalid-feedback">{error.message}</div>}
    </div>
  );
};

export default CustomDatePicker;
